/** Tabellenzelle zum Sortieren: Griff zum Ziehen plus Hoch/Runter-Knöpfe (Touch und Tastatur) */
export function SortCell({ index, count, label, onMove, busy }: { index: number; count: number; label: string; onMove: (from: number, to: number) => void; busy?: boolean }) {
  return (
    <td className="sort-cell">
      <span className="drag-handle" title="Ziehen zum Sortieren" aria-hidden="true">
        ⋮⋮
      </span>
      <button type="button" className="sort-btn" onClick={() => onMove(index, index - 1)} disabled={busy || index === 0} aria-label={`${label} nach oben`} title="Nach oben">
        ↑
      </button>
      <button type="button" className="sort-btn" onClick={() => onMove(index, index + 1)} disabled={busy || index === count - 1} aria-label={`${label} nach unten`} title="Nach unten">
        ↓
      </button>
    </td>
  );
}
